<app-header backgroundImage="assets/header/projects.webp"
            i18n-title title="Unsere Projekte"
            i18n-description
            description="Unsere langjährige Erfahrung basiert auf vielen erfolgreich umgesetzten Projekten. Ausserdem veranschaulichen Sie das breite Spektrum, in dem wir auch Sie unterstützen können, denn zufriedene Kunden sind die beste Referenz."/>

<main>
  @for (entry of references.valueOrDefault().entries; track entry.id) {
    <div class="card card-padding shear" [id]="entry.slug">
      @let fgImage = entry.images?.foreground;
      <div class="shear-inner bg-before bg-img"
           [class.text-white]="entry.images?.background"
           [class.has-image]="entry.images?.background"
           [class.colored]="$odd"
           [style.--bg-img]="entry.images?.background?.source ? `url(${entry.images.background.source})` : 'initial'">
        <div class="row reference inner-content">
          <div class="col-12 col-lg-6">
            <h1>{{ entry.name }}</h1>

            @switch (entry.kind) {
              @case (ReferenceKind.Project) {
                <p>{{ entry.customer.name }}</p>
              }
              @case (ReferenceKind.Product) {
                <p i18n>ser.soft GmbH</p>
              }
              @default never ;
            }

            <div class="fw-bold badges">
              <span i18n>Tag:</span>
              @for (tag of entry.tags; track tag.id) {
                <span class="badge text-bg-info mx-1">{{ tag.name }}</span>
              }
            </div>

            <div class="fw-bold" i18n>
              Technologien: {{ entry.technologyNames.join(', ') }}
            </div>

            @if (fgImage) {
              <img class="d-block d-lg-none align-self-stretch w-auto h-auto" sizes="100vw"
                   [ngSrc]="fgImage.source" [alt]="entry.name" [width]="fgImage.size.width" [height]="fgImage.size.height"/>
            }

            <p [innerHTML]="entry.summary | safeHtml"></p>

            @if (entry.links.length > 0) {
              <div class="row row-cols-auto gx-2">
                @for (link of entry.links; track link.url) {
                  <a target="_blank" class="col" [href]="link.url" >
                    @switch (link.kind) {
                      @case (ReferenceLinkKind.AppStore) {
                        <img width="120" height="40" alt="App Store" i18n-alt
                             [ngSrc]="`assets/images/${locale}/app_store_badge_${entry.images?.background ? 'light' : 'dark'}.svg`"/>
                      }
                      @case (ReferenceLinkKind.Website) {
                        <img width="120" height="40" alt="Webseite" i18n-alt
                             [ngSrc]="`assets/images/${locale}/website_badge_${entry.images?.background ? 'light' : 'dark'}.svg`"/>
                      }
                      @default never ;
                    }
                  </a>
                }
              </div>
            }

            @if (entry.details; as details) {
              <div class="accordion mt-5" [id]="`accordion${entry.id}`">
                <div class="accordion-item">
                  <div class="accordion-header">
                    <button i18n class="accordion-button collapsed" type="button"
                            data-bs-toggle="collapse" aria-expanded="false"
                            [attr.data-bs-target]="`#details${entry.id}`"
                            [attr.aria-controls]="`details${entry.id}`">
                      Feature-Liste
                    </button>
                  </div>
                  <div class="accordion-collapse collapse" [attr.data-bs-parent]="`#accordion${entry.id}`"
                       [id]="`details${entry.id}`">
                    <div class="accordion-body">
                      <ul>
                        @for (feature of details.features; track feature) {
                          <li>{{ feature }}</li>
                        }
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>

          <div class="col-12 col-lg-6 d-none d-lg-block">
            @if (fgImage) {
              <img class="w-100 h-auto align-self-start" sizes="50vw"
                   [ngSrc]="fgImage.source" [alt]="entry.name" [width]="fgImage.size.width" [height]="fgImage.size.height"/>
            }
            @else {
              &nbsp;
            }
          </div>
        </div>
      </div>
    </div>
  }
  @if (references.value().total > references.value().entries.length) {
    <div class="load-more card card-padding shear">
      <div class="shear-inner inner-content text-center">
        <a href="javascript:void(0)" i18n (click)="loadMore(references.value().entries.length)">Mehr laden&hellip;</a>
      </div>
    </div>
  }
</main>
